import { Academy } from './Academy';
import { Bill } from './Bill';
import { Post } from './Post';
import { Attendance } from './Attendance';
import { Chat } from './Chat';
import { Homework } from './Homework';
import { Message } from './Message';
import { Push } from './Push';
import { Report } from './Report';
import { Feature } from './Feature';
import { Common } from './Common';

const Co = {
  Academy,
  Bill,
  Post,
  Attendance,
  Homework,
  Chat,
  Message,
  Push,
  Report,
  Feature,
  Common,
};

export default Co;
